module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-01.e475fd2c.png";